import React from 'react';
import { connect } from 'react-redux';
import { startSetGeoType } from '../actions/globalState';
import {Select} from 'antd';
const Option = Select.Option;

export class GeoType extends React.Component {

  onGeoTypeChange = (text, detailView) => {
    this.props.startSetGeoType(text, detailView);
  };
  render() {
    //console.log('geo type component', this.props)
    return (
      <Select size="large" 
        className="geo-type"
        value={this.props.geo_type}
        onChange={value => this.onGeoTypeChange(value, this.props.detailView)}
        >
        <Option value="Local Government Area">Local Government Area</Option>
        <Option value="Statistical Area 2">Statistical Area 2</Option>
        {this.props.profile === 'Municipal Profile'&& <Option value="Suburb" className="suburb">Suburb</Option> }

      </Select>
    )
  }
}

const mapStateToProps = (state) => ({
  geo_type: state.globalState.geo_type,
  profile: state.globalState.profile,
  detailView: state.globalState.detailView
});

const mapDispatchToProps = (dispatch) => ({
  startSetGeoType: (text, detailView) => dispatch(startSetGeoType(text, detailView))
});

export default connect(mapStateToProps, mapDispatchToProps)(GeoType);



// WEBPACK FOOTER //
// ./src/components/GeoType.js